angular.module("avant.customer_applications.directives").directive "appField", [
  '$state',
  '$templateCache',
  '$compile',
  '$timeout'
  ($state, $templateCache, $compile, $timeout) ->
    restrict: 'A'
    scope:
      section_config: "=appField"
      app_field_page: "@appFieldPage"
      app_field_index: "=appFieldIndex"
    link: (scope, element, attrs) ->
      # could use scope.$parent.page (same as scope.app_field_page)
      template = $templateCache.get "/customer_application_renderer/#{scope.app_field_page}/#{scope.section_config.section}.html" 
      element.hide()

      scope.section_config.visible = false

      element.html(template)
      $compile(element.contents())(scope.$parent)

      angular.element("input", element).each (idx, target) ->
        input = angular.element(target)
        # Notify the mobile-compact-hide directive
        input.bind 'focus', (event) -> 
          scope.$emit 'app:field:focus', input
          $timeout ->
            scope.$parent.setSnapIndex scope.app_field_index
        input.bind 'blur', (event) -> scope.$emit 'app:field:blur', input

        # The legend tags before the hidden inputs
        # are a workaround for an iOS 7 performance bug
        input.before '<legend class="hidden"></legend>'

      scope.$emit("app_field_loaded:#{scope.app_field_page}", scope.section_config)

      scope.$on("section_visibility:#{scope.app_field_page}:#{scope.section_config.section}", (event, data) ->
        if scope.section_config.visible isnt data
          scope.section_config.visible = data
          if data
            element.show()
          else
            element.hide()
      )
]
